import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import LandingView from '../views/LandingView.vue';
import CouponView from '../views/Coupon/CouponView.vue';
import ScannerView from '../views/Coupon/ScannerView.vue';
import CouponLists from '../views/CouponLists.vue';
import AccountLists from '../views/AccountLists.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    component: () => import('@/views/LoginView.vue'),
    name: 'Login',
    meta: {
      requiresVisitor: true
    },
  },
  {
    path: '/',
    name: 'Home',
    redirect: '/coupon-entry',
    component: LandingView,
    children: [
      { path: 'coupon-entry', name: 'CouponEntry', component: CouponView },
      { path: 'coupon-lists', name: 'CouponLists', component: CouponLists },
      { path: 'account-lists', name: 'AccountLists', component: AccountLists },
      { path: 'coupon-entry/scanner/:id', name: 'Scanner', component: ScannerView },
      { path: 'payment-dates', name: 'PaymentDates', component: () => import('@/views/PaymentDatesView.vue') },
      { path: 'update-payment-date', redirect: { name: 'PaymentDates' } },
      { path: 'modification-requests', name: 'ModificationRequests', component: () => import('@/views/ModificationRequestsView.vue') },
      { path: 'corporate-benefits', name: 'CorporateBenefits', component: () => import('@/views/CorporateBenefitsView.vue') },
      { path: 'notifications', name: 'Notifications', component: () => import('@/views/NotificationsView.vue') },
      { path: 'notifications/:id', name: 'NotificationDetail', component: () => import('@/views/NotificationDetailView.vue') },
      { path: 'users', name: 'Users', component: () => import('@/views/UsersView.vue') },
    ],
    meta: {
      requiresAuth: true
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
})

export default router
